<template>
  <nav class="navbar">
    <div class="logo navbaritem">
      <a href="javascript:void(0)" @click="gotoHomePage" v-text="branding"></a>
    </div>
    <div class="search navbaritem">
      <SearchBar />
    </div>
    <div class="menu navbaritem">
      <ul class="nav" v-if="AuthStore.state.isLoggedIn">
        <li><router-link to="/">Anasayfa</router-link></li>
        <li><router-link to="/listelerim">Listelerim</router-link></li>
        <li><router-link to="/favorilerim">Favorilerim</router-link></li>
        <li><router-link to="/takip"><font-awesome-icon icon="users"/></router-link></li>
        <li><router-link to="/cikis"><font-awesome-icon icon="sign-out-alt" /></router-link></li>
      </ul>
      <ul class="nav" v-else>
        <li><router-link to="/">Anasayfa</router-link></li>
        <li><router-link to="/kayit-ol">Kayıt Ol</router-link></li>
        <li><router-link to="/giris-yap"><font-awesome-icon icon="sign-in-alt" /></router-link></li>
      </ul>
    </div>
  </nav>
</template>

<script setup>
import { defineProps } from 'vue';
import AuthStore from "../stores/AuthStore";
import router from "../router";
import SearchBar from "./SearchBar";

defineProps({
  branding: {
    type: String,
    required: true
  }
});

function gotoHomePage() {
  router.push('/');
}
</script>

<style scoped>
  .navbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .navbaritem {
    flex: 1;
  }

  .logo a {
    text-decoration: none;
    text-align: center;
    display: inline-block;
    padding: 12px 20px;
    color: #739ce7;
    font-weight: bold;
    font-size: 2em;
  }

  .menu {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .menu .nav {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    list-style: none;
  }

  .nav .router-link-active.router-link-exact-active {
    background-color: #739ce7;
  }

  .nav li a {
    color: white;
    padding: 12px 20px;
    text-decoration: none;
    border-radius: 100px;
    transition: background-color .3s ease;
    display: inline-block;
    margin: 0 5px;
  }

  .nav li a:visited {
    color: white;
  }

  .nav a:hover {
    background-color: #739ce7;
  }
</style>